export { ResultsSportFilter as Menu } from '~/web-frontend-components/results/live/Menu';
export { ResultSportsTables as Tables } from '~/web-frontend-components/results/live/Tables';



// WEBPACK FOOTER //
// ./src/web-frontend-components/results/ResultsLive.js